import React from 'react';
import { Col, Container, Row, Tab } from 'react-bootstrap';
import { IOverviewTabProps } from './types/IOverviewTabProps';
import ContentBlocks from '../../../ContentBlocks';

const OverviewTab = ({ data, product, fallback }: IOverviewTabProps) => {
  return (
    <>
      <Tab.Pane eventKey="overview" className="overview-tab mt-60">
        <ContentBlocks data={data} product={product} />

        {Boolean(fallback) && (
          <Container className={`mt-5 pt-4`}>
            <Row>
              <Col>
                <p>{product?.description}</p>
              </Col>
            </Row>
          </Container>
        )}
      </Tab.Pane>
    </>
  );
};

export default OverviewTab;
